import { render, staticRenderFns } from "./computer.vue?vue&type=template&id=e214b13a&scoped=true"
import script from "./computer.vue?vue&type=script&lang=js"
export * from "./computer.vue?vue&type=script&lang=js"
import style0 from "./computer.vue?vue&type=style&index=0&id=e214b13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e214b13a",
  null
  
)

export default component.exports